import { Image, Tag } from 'antd';
import { formatDateTime } from '@/utils/date';
import { getMediaImageUrl } from '@/utils/media';
import styles from './BlogArticleView.module.scss';

export interface BlogArticlePreviewData {
  title: string;
  slug?: string;
  content?: string;
  coverImage?: string;
  tags?: string[];
  isPublished?: boolean;
  publishedAt?: string | null;
}

interface BlogArticleViewProps {
  article: BlogArticlePreviewData;
  showStatus?: boolean;
}

export function BlogArticleView({ article, showStatus = true }: BlogArticleViewProps) {
  const coverUrl = getMediaImageUrl(article.coverImage);
  const publishedLabel = article.publishedAt ? formatDateTime(article.publishedAt) : null;

  return (
    <article className={styles.article}>
      {coverUrl ? (
        <div className={styles.hero}>
          <Image
            src={coverUrl}
            alt={article.title}
            className={styles.coverImage}
            preview={{ src: coverUrl }}
          />
        </div>
      ) : null}

      <div className={styles.body}>
        <div className={styles.metaRow}>
          {showStatus ? (
            <Tag color={article.isPublished ? 'success' : 'default'}>
              {article.isPublished ? 'Published' : 'Draft'}
            </Tag>
          ) : null}
          {publishedLabel ? <span className={styles.date}>{publishedLabel}</span> : null}
          {article.slug ? <span className={styles.slug}>/{article.slug}</span> : null}
        </div>

        <h1 className={styles.title}>{article.title || 'Untitled article'}</h1>

        {article.tags && article.tags.length > 0 ? (
          <div className={styles.tags}>
            {article.tags.map((tag) => (
              <Tag key={tag}>{tag}</Tag>
            ))}
          </div>
        ) : null}

        {article.content ? (
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: article.content }} />
        ) : (
          <p className={styles.emptyContent}>No content yet.</p>
        )}
      </div>
    </article>
  );
}
